{
  "de": {
    "comma": ", "
  },
  "en": {
    "comma": ", "
  },
  "fr": {
    "comma": ", "
  },
  "es": {
    "comma": ", "
  },
  "it": {
    "comma": ", "
  },
  "zh": {
    "comma": "、"
  },
  "pt": {
    "comma": ", "
  },
  "ru": {
    "comma": ", "
  },
  "ar": {
    "comma": "و"
  }
}